import React, { useCallback, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton, ListItemIcon, SvgIcon } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { ReactComponent as RemoveIcon } from 'assets/icons/Remove.svg';
import { actions } from 'store';
import { useDispatch } from 'react-redux';
import { alerts } from 'keys';

const MenuCell = (props) => {
    const { cell } = props
    let value = cell.getValue()

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch()

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = useCallback(() => {
        dispatch(actions.setAlerts({
            key: alerts.removeTicket,
            value: { open: true, props: value }
        }))
        handleClose()
    }, [value])

    return (
        <div>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <MoreVert />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleDelete}>
                    <ListItemIcon>
                        <SvgIcon component={RemoveIcon} inheritViewBox />
                    </ListItemIcon>
                    {"מחיקה"}
                </MenuItem>
            </Menu>
        </div>
    );
}

export default MenuCell 
